import styled from 'styled-components';

const PricingPlanContainer = styled.div`
    background-color: #fcfcfc;
    text-align: center;
    .head {
        padding: 40px 20px;
        border-top: 1px solid var(--main-color);
        border-bottom: 1px solid var(--main-color);
        h3 {
            font-weight: normal;
            margin-bottom: 20px;
            text-transform: uppercase;
        }
    }
    .head span {
        font-size: 60px;
        font-weight: bold;
        &::before {
            content: '$';
            font-size: 25px;
            position: relative;
            top: -40px;
            margin-right: 15px;
            font-weight: normal;
        }
        &::after {
            content: '/Mo';
            font-size: 20px;
            position: relative;
            right: -15px;
        }
    }
    ul {
        border-bottom: 1px solid var(--main-color);
        li {
            padding: 20px;
            position: relative;
        }
        &:not(:last-child)::after {
            content: '';
            width: 140px;
            height: 1px;
            background-color: var(--main-color);
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
        }
    }
    .foot a {
        display: block;
        padding: 20px 20px;
        text-decoration: none;
        border: 1px solid var(--main-color);
        width: fit-content;
        margin: 30px auto;
    }
`;

export default PricingPlanContainer;
